import { Box, useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ArrayInput, BooleanInput, Edit, Loading, NumberInput, required, SelectInput, SimpleForm, TextInput, useEditController, useNotify } from 'react-admin';
//import { FormSpy } from 'react-final-form';
import SimpleFormIterator from '../formIterator/SimpleFormIterator';
import { differentDeZero, formatAdresse,has_role, formatPhone, get_total_general, infOuEgalA100, isExpGui, json, telValidationDest, telValidationExp, valideTotal } from '../references.js';
import { FormSpy } from 'react-final-form';

export const styles = {
    nom: { display: 'inline-block', marginRight: 32 },
    tel: { display: 'inline-block', marginRight: 32 },
    email: { display: 'inline-block' },
    marginRight:{ display: 'inline-block', marginRight:32},
    marginPoids:{ display: 'inline-block', marginLeft:32},
    //email: { width: 544 },
    address: { maxWidth: 544 },
    zipcode: { display: 'inline-block' },
    city: { display: 'inline-block', marginLeft: 32 },
    comment: {
        maxWidth: '20em',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        backgroundColor:'#000'
    },
    password: { display: 'inline-block' },
    confirm_password: { display: 'inline-block', marginLeft: 32 },
};

const marginRight ={marginRight:10};


const  EditOrder =(props,...rest) => {
    const [listFretDisponible, setListFretDisponible] = useState([]);
    const [formData, setFormData] = useState();
    const notify = useNotify();
    const [total, setTotal] = useState(0);
    const {permissions}=props;
    
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    let validationPhoneExp;
    let validationPhoneDest;
    let campType;

   const { record } = useEditController(props);

   let valInitiales;
   if(record && record.order && record.order.client_exp){
       valInitiales={"camp_id":record.order.campagne.id,
       "nom_exp":record.order.client_exp.fullname,"tel_exp1":formatPhone(record.order.client_exp.telephone1),
       "tel_exp2":formatPhone(record.order.client_exp.telephone2),
       "email_exp":record.order.client_exp.email,
       "adresse_exp":formatAdresse(record.order.client_exp.adresse),
       "nom_dest":record.order.client_dest.fullname,"tel_dest1":formatPhone(record.order.client_dest.telephone1),
       "tel_dest2":formatPhone(record.order.client_dest.telephone2),
       "email_dest":record.order.client_dest.email,
       "adresse_dest":formatAdresse(record.order.client_dest.adresse),
       "lines_colis":record.orderLinesList,"gratuit_excep":record.order.gratuit_excep,"urgent":record.order.urgent,
       "frais_enlevement":record.order.frais_enlevement,
       "ancien_code":record.order.ancien_code,
       "code":record.order.code
    };

    const {resource,location}=props;
    const url=location.pathname;
    campType=resource;
     if(has_role(permissions,'ROLE_MANAGER')){
        const index  = url.indexOf('?resource=');
        let camp_type = url.substr(index);
        camp_type=camp_type.replace('?resource=','');
        const i=camp_type.indexOf('/');
        camp_type=camp_type.substr(0,i);
        campType=camp_type;
     }
     validationPhoneExp=isExpGui(permissions) || (has_role(permissions,'ROLE_MANAGER') && campType==='aerien_de_cnkry') ? telValidationDest:telValidationExp;
     validationPhoneDest=isExpGui(permissions) || (has_role(permissions,'ROLE_MANAGER') && campType==='aerien_de_cnkry') ? telValidationExp:telValidationDest;
   }
   
   useEffect(() => {
        fetch(process.env.REACT_APP_URL+"/camp/getCampagneByTypeAndStatus?status=ATTENTE&resource="+campType, 
            { 
                method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else if(data.totalElements===0) {
                notify("Aucune campagne aérien n'est disponible !","warning");
            }else{
                setListFretDisponible(data.content);
            }
        }).catch((e) => {
            notify("Erreur lors du processus de récupération des campagnes !", 'warning')
        });
    }, []);

   useEffect(() => {
    const total_general=get_total_general(formData);
    setTotal(total_general);
  }, [formData]);  

  
  const  change=(formValues)=>{
      if(typeof formValues !== 'undefined' && formValues !== undefined){
        const total_general=get_total_general(formValues);
        setTotal(total_general);
      } 
  }
  
  const isCampStatusAttente=(listCampAttente,camp_id)=>{
    for (var j = 0; j < listCampAttente.length; j++) {
        if(listCampAttente[j].id===camp_id) return true;
    }
    return false;
  }
  //console.log(valInitiales.camp_id)
  
  
  return (
    
    listFretDisponible.length>0  ? 

      <Edit {...props} title={"Total : " +total +" € - Code : "+valInitiales.code} >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none"  initialValues={valInitiales} >    
            <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
            {isCampStatusAttente(listFretDisponible,valInitiales.camp_id) ? 
              <SelectInput source="camp_id"  choices={listFretDisponible} 
                    validate={required()}  label="Campange" 
                    style={isSmall ? null:{width:'58%',marginRight:30}}  
                    fullWidth
                />
                :
            <SelectInput source="camp_id"  disabled choices={listFretDisponible} 
                validate={required()}  label="Campange" 
                style={isSmall ? null:{width:'58%',marginRight:30}}  
                fullWidth
            />
            }
            <BooleanInput  source="urgent" fullWidth label="Urgent" style={isSmall ? null:{width:'38%',marginTop:15}}  />
            </Box>  

           <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
            {isSmall ? <TextInput  source="nom_exp" fullWidth label="Nom expéditaire"  style ={isSmall ? null:marginRight} validate={required()}   /> :
                       <TextInput  source="nom_exp"  label="Nom expéditaire"  style ={isSmall ? null:marginRight} validate={required()}   /> 
            }
            {isSmall ? <TextInput source="tel_exp1" fullWidth label="Telephone expéditaire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneExp]}  />:
                       <TextInput source="tel_exp1" label="Telephone expéditaire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneExp]}  />
            }
            {isSmall ? null:<TextInput source="tel_exp2"  label="Telephone expéditaire 2"  style ={marginRight}   />}
            {isSmall ? null:<TextInput source="email_exp"  label="Email expéditaire"  style ={marginRight}  />}
            {isSmall ? <TextInput source="adresse_exp"  fullWidth label="Adresse expéditaire"   /> : 
                       <TextInput source="adresse_exp"  label="Adresse expéditaire"   />}
           </Box>  

           <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
           {isSmall ?<TextInput  source="nom_dest" fullWidth label="Nom destinataire"  style ={isSmall ? null:marginRight} validate={required()}   />:
                     <TextInput  source="nom_dest"  label="Nom destinataire"  style ={isSmall ? null:marginRight} validate={required()}   />
           }
            {isSmall ?<TextInput source="tel_dest1" fullWidth label="Telephone destinataire 1*"  style ={isSmall ? null:marginRight} validate={[validationPhoneDest]}  />:
                      <TextInput source="tel_dest1"  label="Telephone destinataire 1*"  style ={marginRight} validate={[validationPhoneDest]}  />
            }
            {isSmall ? null:<TextInput source="tel_dest2"  label="Telephone destinataire 2"  style ={marginRight}  />}
            {isSmall ? null:<TextInput source="email_dest"  label="Email destinataire"  style ={marginRight}  />}
            {isSmall ? <TextInput fullWidth source="adresse_dest"  label="Adresse destinataire"   />:
                       <TextInput source="adresse_dest"  label="Adresse destinataire"   />}
           </Box>  
          
            <ArrayInput validate={required()} expanded={true} source="lines_colis" fullWidth {...rest} label="Ajouter les colis" >
                <SimpleFormIterator  fullWidth {...rest}>
                    <TextInput source="description" label="Description"  {...rest} style ={marginRight} validate={required()}   />            
                    <NumberInput min="1" max="100" source="quantite"   label="Quantité"   validate={[required(),differentDeZero,infOuEgalA100]} style={marginRight} />
                    <NumberInput min="1" source="poids" label="Poids(kg)" style ={marginRight} validate={[required(),differentDeZero]} />   
                    <NumberInput min="0" source="prix_unitaire" label="Prix unitaire"   validate={[required(),differentDeZero]} style ={marginRight} />
                    <NumberInput {...rest} min="0" source={"total_line"} label="Total" style ={marginRight} validate={[valideTotal]}/>
                </SimpleFormIterator>
            </ArrayInput>

            <Box display="flex"    fullWidth justifyContent="space-btween" flexWrap="wrap">
            <TextInput {...rest} style={isSmall ? {width:'100%'}:{width:'20%',marginRight:20}} fullWidth source="ancien_code"  label="Ancien code"   />
            <NumberInput {...rest} style={isSmall ? {width:'100%'}:{width:'20%',marginRight:20}} fullWidth source="frais_enlevement"  label="Frais enlèvement"   />            
            <BooleanInput  source="gratuit_excep"  label="Gratuit exceptionnel" style={isSmall ? null:{width:'20%',marginTop:15}}  />
           </Box>
           <FormSpy

            onChange={props => {
                change(props.values);
            }}
            />
        </SimpleForm>
    </Edit> :<Loading />
    );
}

export default EditOrder;
